const resources = { backToTop: 'Retour en haut de page' };

module.exports = function getResource(label) {
    return resources[label];
};
